exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".item-big[data-v-07df4e3a]:hover{font-weight:700}.break-row[data-v-07df4e3a]{white-space:pre-wrap;word-wrap:break-word;overflow:hidden;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:5}", ""]);

// exports
